import React, { useCallback } from 'react';
import { Button } from '@arco-design/web-react';
import { t } from '@bay-email/core';
import { useBlock, useFocusIdx } from '@bay-email/editor';
import { getInheritedTypography } from './inheritedTypography';

// Rendered only for blocks that still carry typography from the old panel.
export function ResetInheritedTypography() {
	const { focusBlock, change } = useBlock();
	const { focusIdx } = useFocusIdx();
	const inherited = getInheritedTypography(focusBlock?.attributes);

	const onReset = useCallback(() => {
		inherited.forEach(name => change(`${focusIdx}.attributes.${name}`, undefined));
	}, [change, focusIdx, inherited]);

	if (inherited.length === 0) return null;

	return (
		<div style={{ marginTop: 16 }}>
			<Button
				long
				onClick={onReset}
			>
				{t('Reset block text formatting')}
			</Button>
		</div>
	);
}
